import { useResetAtom } from 'jotai/utils';
import { featureHubState } from '../store/feature-atoms';
import { useResetPermissions } from './usePermissions';
import { clearResolverCache } from './useResolverQueryClient';

export const useOnLogout = () => {
  const resetFeatureHubState = useResetAtom(featureHubState);
  const resetPermissions = useResetPermissions();
  return () => {
    resetFeatureHubState();
    resetPermissions();
    clearResolverCache();
  };
};
